export default "__VITE_ASSET__C9oQ21iH__"